<template>
  <wiskModal :visible="!!editAction" @hide="setGlobalAction({ type: 'inventoryUpload', action: null })"
    :title="translations.txtInventoryUploadTitle"
    size="lg" :okDisabled="okDisabled" @ok="save" :okText="translations.txtGenericUpload" preventOKClose>
    <div v-if="editAction" class="wisk-inventory-upload" style="min-height: 400px;">
      <b-container fluid>
        <b-row>
          <b-col class="mb-2-m px-0-m">
            <dateRangeSelector v-model="selectedDateRange" :shortcuts="false"
              :notBefore="venue.last_locked_inventory_date && new Date(venue.last_locked_inventory_date)" />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="">
            <b-input-group class="mt-2">
              <fileInput accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx, .csv" class="" @reset="file = null" v-model="file" />
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-2">
            <a href="https://wiskai-report-templates.s3.ca-central-1.amazonaws.com/WISK_Inventory_Upload_TEMPLATE.csv" target="_blank" rel="noreferrer">
              {{ translations.txtInventoryUploadTemplateLink }}
            </a>
          </b-col>
        </b-row>
        <div class="mt-5" v-if="uploadErrors && uploadErrors.length">
          <h5> {{ translations.txtInventoryUploadErrors }} </h5>
          <b-row v-for="(error, index) in uploadErrors" :key="index">
            <b-col class="text-danger">
              {{ error }}
            </b-col>
          </b-row>
        </div>
      </b-container>
      <wiskLoading :loading="loading" />
    </div>
    <confirm ref="confirmDialog" />
  </wiskModal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import get from 'lodash.get'
import api from '@/api'
import dateRangeSelector from '@/components/common/DateRangeSelector'
import fileInput from '@/components/common/FileInput'

export default {
  name: 'InventoryUploader',
  components: { dateRangeSelector, fileInput },
  props: {
    editAction: {
      type: Object
    }
  },
  data() {
    return {
      selectedDateRange: [new Date(), new Date()],
      loading: false,
      file: null,
      uploadErrors: []
    }
  },
  computed: {
    ...mapState(['translations', 'user']),
    ...mapGetters(['venue']),
    okDisabled() {
      return !this.file || !this.selectedDateRange[0] || !this.selectedDateRange[1]
    }
  },
  methods: {
    ...mapActions(['setGlobalAction', 'notify']),
    save() {
      let formData = new FormData()
      this.loading = true
      formData.append('data', this.file)

      if (this.$refs.confirmDialog) {
        this.$refs.confirmDialog.confirm({
          callback: () => {
            api.uploadInventory(this.selectedDateRange[0].toISOString(), this.selectedDateRange[1].toISOString(), formData)
              .then(() => {
                this.setGlobalAction({ type: 'inventoryUpload', action: null })
                this.notify({
                  message: this.translations.txtInventoryUploadSuccess,
                  type: 'success'
                })
              })
              .catch(e => {
                let errorInfo = get(e, 'data.info.errors')
                if (Array.isArray(errorInfo)) {
                  this.uploadErrors = errorInfo
                } else {
                  this.setGlobalAction({ type: 'inventoryUpload', action: null })
                }
                this.loading = false
              })
          },
          cancelCallback: () => {
            this.loading = false
          },
          message: this.translations.txtInventoryUploadMessage,
          title: this.translations.txtInventoryUploadConfirmTitle
        })
      }
    }
  }
}
</script>

<style lang="scss"></style>
